export enum HeaderTheme {
  default = 'default',
  backgroundBlur = 'backgroundBlur',
  dark = 'dark',
}
